import {
  Flex,
  Text,
  Badge,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  useColorModeValue,
} from '@chakra-ui/react';

interface ReadOnlyCollapsibleCardProps {
  title: string;
  subtitle?: string;
  isDisabled?: boolean;
  children: React.ReactNode;
}

const ReadOnlyCollapsibleCard = ({
  title,
  subtitle,
  isDisabled = false,
  children,
}: ReadOnlyCollapsibleCardProps) => {
  const borderColor = useColorModeValue('gray.200', 'whiteAlpha.100');

  return (
    <AccordionItem
      isDisabled={isDisabled}
      borderRadius="lg"
      mb={3}
      shadow="md"
      borderWidth="1px"
      borderColor={borderColor}
    >
      <AccordionButton
        _expanded={{ borderBottomRadius: 0 }}
        borderRadius="md"
        _hover={{ bg: 'gray.200' }}
        py={{ base: 3, md: 2 }}
      >
        <Flex
          flex="1"
          align={{ base: 'flex-start', sm: 'center' }}
          justify="space-between"
          pr={4}
          direction={{ base: 'column', sm: 'row' }}
          gap={{ base: 2, sm: 0 }}
        >
          {subtitle ? (
            <Flex direction="column" align="flex-start">
              <Text fontWeight="600" fontSize={{ base: 'sm', md: 'md' }}>
                {title}
              </Text>
              <Text fontSize="xs" color="gray.500">
                {subtitle}
              </Text>
            </Flex>
          ) : (
            <Text fontWeight="600" fontSize={{ base: 'sm', md: 'md' }}>
              {title}
            </Text>
          )}
          {isDisabled && (
            <Badge colorScheme="gray" variant="subtle">
              Excluded
            </Badge>
          )}
        </Flex>
        <AccordionIcon />
      </AccordionButton>
      <AccordionPanel pb={4}>{children}</AccordionPanel>
    </AccordionItem>
  );
};

export default ReadOnlyCollapsibleCard;
